import NewsletterCheckboxConfirmationProvider from './hooks/useNewsletterCheckboxConfirmation';

import { NewsletterCheckboxConfirmationProps } from './@types/NewsletterCheckboxConfirmationProps';
import NewsletterCheckboxConfirmationContainer from './handles/NewsletterCheckboxConfirmationContainer';

const NewsletterCheckboxConfirmation = (props: NewsletterCheckboxConfirmationProps) => (
	<NewsletterCheckboxConfirmationProvider {...props}>
		<NewsletterCheckboxConfirmationContainer />
	</NewsletterCheckboxConfirmationProvider>
);

export default NewsletterCheckboxConfirmation;
